import React, { useState } from 'react'
import { Form, InputGroup, Col, Button, Accordion, Card, Container } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import CustomSpinner from '../../generic/CustomSpinner';
import { ErrorMessage } from '@hookform/error-message';

const AddCursosCompania = ({ setSelected, selected, cursosSTJ, handleForm, }) => {

  const [validated] = useState(false);
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    getValues,
    watch,
  } = useForm({})

  const onSubmit = (data) => {
    handleForm(data);
  };

  return (

    <Container className="my-5 position-relative">
      <CustomSpinner loading={loading} animation={"border"} />
      <Form noValidate validated={validated} onSubmit={handleSubmit(onSubmit)} className="border rounded p-4">


        <Form.Row>
          <Form.Group as={Col} xs={12} md controlId="provincia-vida-religiosa">
            <Form.Label>{"Cursos STJ "} *</Form.Label>
            <Form.Control as="select" custom isInvalid={errors.coursesSTJid} {...register("coursesSTJId", { required: "Este campo es obligatorio" })}>

              <option value=""> - Seleccione un curso -</option>
              {cursosSTJ.length ? cursosSTJ?.map(curso => {
                return (
                  <option key={curso.id} value={curso.id}>
                    {`${curso.anio} ${curso.nombre}`}
                  </option>
                );
              })
                :
                "No hay cursos en alta"}
            </Form.Control>
            <small><ErrorMessage errors={errors} name="coursesSTJId" /></small>

          </Form.Group>
        </Form.Row>
        <Form.Row>

        </Form.Row>
        <Button type='submit' className='button-outline-primary' variant="outline-primary">Añadir</Button>
      </Form>
    </Container>

  )
}
export default AddCursosCompania